(() => {
  if (window.MkUpsell) return;
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  const nativeFetch = window.fetch.bind(window);
  function money(cents, fmt) {
    if (window.Shopify && Shopify.formatMoney) { try { return Shopify.formatMoney(cents, fmt); } catch (e) {} }
    return '$' + (cents / 100).toFixed(2);
  }
  function syncShipping(cart) {
    document.querySelectorAll('[data-mk-ship]').forEach((el) => {
      const threshold = Number(el.dataset.threshold) || 14900;
      const total = cart.total_price;
      const prepaid = cart.items.some((i) => /prepaid/i.test(i.selling_plan_allocation?.selling_plan?.name || ''));
      const remaining = threshold - total;
      const msg = el.querySelector('[data-mk-ship-msg]');
      const track = el.querySelector('[data-mk-ship-track]');
      const bar = el.querySelector('[data-mk-ship-bar]');
      el.hidden = cart.item_count === 0;
      const fmt = (c) => money(c, el.dataset.moneyFormat);
      el.classList.toggle('mk-ship--done', !prepaid && remaining <= 0);
      if (prepaid) msg.innerHTML = 'Your plan ships free';
      else if (remaining <= 0) msg.innerHTML = '<svg class="mk-ship__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3 3 7-7" fill="none" stroke="#C99C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>You\'ve unlocked free FedEx 2Day (contiguous United States)';
      else msg.innerHTML = '<span class="mk-ship__amt">' + fmt(remaining).replace(/[.,]00(?=\D*$)/, '') + '</span> away from free FedEx 2Day on orders of $149+ (contiguous United States)'; /* Oct 30: one line */
      const sub = el.querySelector('[data-mk-ship-sub]');
      if (sub) sub.hidden = true; /* Oct 30: one line; the $149 line now lives in the message */
      const pct = Math.min(100, Math.floor((total * 100) / threshold));
      track.hidden = prepaid;
      track.setAttribute('aria-valuenow', pct);
      bar.style.width = pct + '%';
    });
  }

  let syncSeq = 0;
  async function syncHidden(cart) {
    const mySeq = ++syncSeq;
    try {
      if (!cart) cart = await (await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
      if (mySeq !== syncSeq) return; // MISHKA cartfix3: a newer cart read is in flight; only the latest paints
      syncShipping(cart);
      const ids = new Set(cart.items.map((i) => String(i.product_id)));
      document.querySelectorAll('[data-mk-upsell]').forEach((row) => {
        let shown = 0;
        row.querySelectorAll('.mk-upsell__item').forEach((li) => {
          const inCart = ids.has(li.dataset.productId);
          li.hidden = inCart;
          if (!inCart) shown++;
        });
        row.hidden = shown === 0;
      });
    } catch (e) {}
  }

  async function add(btn) {
    btn.setAttribute('aria-busy', 'true');
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = !!document.getElementById('main-cart');
    const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (drawer && !onCartPage) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'add failed');
      try { // MISHKA cartdate (Oct 21): give the add-on the same Identixweb delivery date as the cart's dated item
        const c = await (await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
        const a = c.attributes || {}, key = 'product_' + btn.dataset.variantId;
        const src = Object.keys(a).find((k) => /^product_\d+$/.test(k) && k !== key && a[k]);
        if (a.calendar_type === 'product' && !a[key] && src) {
          const parts = a[src].split(' |&| ');
          parts[0] = (data.items && data.items[0] && data.items[0].title) || parts[0];
          await nativeFetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { [key]: parts.join(' |&| ') } })
          });
        }
      } catch (e) {}
      if (onCartPage || !drawer || !data.sections) { window.location.reload(); return; }
      const item = data.items[0];
      document.querySelector('cart-notification')?.close?.();
      drawer.renderContents({ ...item, sections: data.sections });
      syncHidden();
    } catch (e) {
      window.location.reload();
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mk-upsell__add');
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });

  // The add-to-cart pop-up is not re-rendered by the theme, so re-check the cart whenever it opens.
  customElements.whenDefined('cart-notification').then(() => {
    const C = customElements.get('cart-notification');
    const orig = C.prototype.renderContents;
    C.prototype.renderContents = function (...args) { const r = orig.apply(this, args); syncHidden(); return r; };
  });
  // Live updates: after any theme cart add/change/update/clear request, re-fetch /cart.js.
  let syncTimer;
  const queueSync = () => { clearTimeout(syncTimer); syncTimer = setTimeout(() => syncHidden(), 120); };
  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(queueSync, queueSync);
    }
    return p;
  };
  document.addEventListener('DOMContentLoaded', () => syncHidden());
  window.MkUpsell = { syncHidden };
})();
